<template>
  <div id="SectionEcovadisDifference">
    <UIContainer>
      <SectionTitle class="SectionEcovadisDifference__title">
        <template #title>
          The <UITitleHighlight>Sustainalyse</UITitleHighlight> difference
        </template>
        <template #description>
          Sustainalyse automates your EcoVadis assessment, helping you achieve a
          higher score faster, reduce manual effort, and maintain continuous
          improvement.
        </template>
      </SectionTitle>
      <UIContentSwitcher
        defaultItemKey="without-sustainalyse"
        :items="[
          { id: 'without-sustainalyse', label: 'Without Sustainalyse' },
          { id: 'with-sustainalyse', label: 'With Sustainalyse' },
        ]"
      >
        <template #without-sustainalyse>
          <img
            class="SectionEcovadisDifference__image"
            src="./assets/ecovadisDifference/withoutSustainalyse.avif"
            alt="Without Sustainalyse audit"
            loading="lazy"
          />
        </template>
        <template #with-sustainalyse>
          <img
            class="SectionEcovadisDifference__image"
            src="./assets/ecovadisDifference/withSustainalyse.avif"
            alt="With Sustainalyse audit"
            loading="lazy"
          />
        </template>
      </UIContentSwitcher>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIContentSwitcher from '@/views/components/ui/contentSwitcher/UIContentSwitcher.vue'
import UITitleHighlight from '@/views/components/ui/typography/UITitleHighlight.vue'
</script>

<style lang="scss" scoped>
#SectionEcovadisDifference {
  background: $color-white;
  .SectionEcovadisDifference__title {
    max-width: 48rem;
    text-align: center;
    margin: 0 auto 4rem;
  }

  .SectionEcovadisDifference__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 1rem;
    box-shadow:
      0 24px 48px -12px
        var(--Colors-Effects-Shadows-shadow-2xl_01, rgba(0, 16, 53, 0.18)),
      0 4px 4px -2px
        var(--Colors-Effects-Shadows-shadow-2xl_02, rgba(0, 16, 53, 0.04));
  }

  .SectionEcovadisDifference__cards {
    margin-top: 4rem; // spacing before cards grid
  }

  :deep(.UIContentSwitcher) {
    justify-content: center;
  }
}
</style>
